module.exports = __webpack_public_path__ + "media/images/expert__beni-huggel-af5ea276775ebbac4a8f065aeb1344b5.png";